
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-center min-h-[60vh]">
        <Card className="w-full max-w-md shadow-lg">
          <CardHeader className="text-center pb-4">
            <div className="text-6xl font-bold text-honeycomb mb-4">404</div>
            <CardTitle className="text-jungle text-xl">Page Not Found</CardTitle>
            <CardDescription>
              Oops! The page you're looking for doesn't exist or has been moved.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-center text-sm text-gray-600 mb-6">
              You tried to access: <code className="bg-gray-100 px-2 py-1 rounded text-xs">{location.pathname}</code>
            </div>
            
            <div className="flex flex-col space-y-3">
              <Button 
                onClick={handleGoHome}
                className="w-full bg-honeycomb hover:bg-amber-500 text-white"
              >
                <Home className="mr-2 h-4 w-4" />
                Go to Home
              </Button>
              
              <Button 
                variant="outline"
                onClick={handleGoBack}
                className="w-full"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go Back
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  );
};

export default NotFound;
